import { useEffect } from 'react';
import withRouter, { WithRouterProps } from 'routes/withRouter';

type CacheBusterProps = {
  children: React.ReactNode;
} & WithRouterProps;

const hardReload = () => {
  if ('caches' in window) {
    window.caches.keys().then((names) => {
      for (let name of names) window.caches.delete(name);
    });
  }
  window.location.reload();
};

const checkMeta = async () => {
  try {
    const response = await fetch(`/meta.json?q=${new Date().getTime()}`, { cache: 'no-cache' });
    const meta = await response.json();
    const version = JSON.parse(localStorage.getItem('APP_VERSION') || 'null');
    if (version && version !== meta.version) {
      hardReload();
    }
    localStorage.setItem('APP_VERSION', meta.version);
  } catch {}
};

const CacheBuster = ({ children, location }: CacheBusterProps) => {
  const pathname = location.pathname;

  useEffect(() => {
    checkMeta();
  }, [pathname]);

  return children;
};

export default withRouter(CacheBuster);
